/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomVariableDto } from './CustomVariableDto';
import {
    CustomVariableDtoFromJSON,
    CustomVariableDtoFromJSONTyped,
    CustomVariableDtoToJSON,
    CustomVariableDtoToJSONTyped,
} from './CustomVariableDto';
import type { EmailRecipientDto } from './EmailRecipientDto';
import {
    EmailRecipientDtoFromJSON,
    EmailRecipientDtoFromJSONTyped,
    EmailRecipientDtoToJSON,
    EmailRecipientDtoToJSONTyped,
} from './EmailRecipientDto';

/**
 * Commande pour envoyer un document par email via un template Brevo generique
 * @export
 * @interface SendDocumentEmailCommand
 */
export interface SendDocumentEmailCommand {
    /**
     * ID du fichier stocke a envoyer en piece jointe
     * @type {string}
     * @memberof SendDocumentEmailCommand
     */
    storedFileId: string;
    /**
     * ID du risque assure (pour recuperer le courtier, la plateforme et l'assure principal)
     * @type {string}
     * @memberof SendDocumentEmailCommand
     */
    risqueAssureId: string;
    /**
     * Type de document (ex - Contrat, Devis, Attestation, etc.)
     * @type {number}
     * @memberof SendDocumentEmailCommand
     */
    fileTypeInt: number;
    /**
     * Variables personnalisees par le front-end (optionnel). Seules les variables avec IsCustomizable=true peuvent etre modifiees
     * @type {Array<CustomVariableDto>}
     * @memberof SendDocumentEmailCommand
     */
    customVariables?: Array<CustomVariableDto>;
    /**
     * Liste des destinataires supplementaires (optionnel). Permet d'envoyer l'email a plusieurs adresses en plus de l'assure principal
     * @type {Array<EmailRecipientDto>}
     * @memberof SendDocumentEmailCommand
     */
    sendTo?: Array<EmailRecipientDto>;
    /**
     * ID du template Brevo a utiliser (optionnel, defaut = 16)
     * @type {number}
     * @memberof SendDocumentEmailCommand
     */
    templateId?: number | null;
}

/**
 * Check if a given object implements the SendDocumentEmailCommand interface.
 */
export function instanceOfSendDocumentEmailCommand(value: object): value is SendDocumentEmailCommand {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('risqueAssureId' in value) || value['risqueAssureId'] === undefined) return false;
    if (!('fileTypeInt' in value) || value['fileTypeInt'] === undefined) return false;
    return true;
}

export function SendDocumentEmailCommandFromJSON(json: any): SendDocumentEmailCommand {
    return SendDocumentEmailCommandFromJSONTyped(json, false);
}

export function SendDocumentEmailCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendDocumentEmailCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
        'risqueAssureId': json['risqueAssureId'],
        'fileTypeInt': json['fileTypeInt'],
        'customVariables': json['customVariables'] == null ? undefined : ((json['customVariables'] as Array<any>).map(CustomVariableDtoFromJSON)),
        'sendTo': json['sendTo'] == null ? undefined : ((json['sendTo'] as Array<any>).map(EmailRecipientDtoFromJSON)),
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
    };
}

export function SendDocumentEmailCommandToJSON(json: any): SendDocumentEmailCommand {
    return SendDocumentEmailCommandToJSONTyped(json, false);
}

export function SendDocumentEmailCommandToJSONTyped(value?: SendDocumentEmailCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'risqueAssureId': value['risqueAssureId'],
        'fileTypeInt': value['fileTypeInt'],
        'customVariables': value['customVariables'] == null ? undefined : ((value['customVariables'] as Array<any>).map(CustomVariableDtoToJSON)),
        'sendTo': value['sendTo'] == null ? undefined : ((value['sendTo'] as Array<any>).map(EmailRecipientDtoToJSON)),
        'templateId': value['templateId'],
    };
}

